export const ANOMALY_EXPORT_MODAL_TITLE = "Data export";
export const ANOMALY_MODAL_PRIMARY_ACTION_LABEL = "Confirm";
export const ANOMALY_MODAL_CLOSE_ACTION_LABEL = "Close";
export const ANOMALY_MODAL_SECONDARY_ACTION_LABEL = "Cancel";
